import g from '#core/global';
import load from '#core/load';


const duo_$ = '.dynamic-duo';
const content_$ = '.dynamic-duo__content';
const item_attr = 'data-dynamic-duo-item';
const trigger_attr = 'data-dynamic-duo-trigger';
const selector_attr = 'data-dynamic-duo-selector';
const default_attr = 'data-dynamic-duo-default';
const item_$ = `[${item_attr}]`;
const trigger_$ = `[${trigger_attr}]`;

let has_dynamic_duo = false;


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('dynamic-duo')) return false;

		load.content(() => {
			has_dynamic_duo = assign_elements();
		});
		load.all(() => {
			has_dynamic_duo = assign_elements();
		});
	},

};

export default module;
module.init();


/**
 * Number the trigger elements in each duo from 1, in content order
 * @param {NodeList} $duos
 */
function assign_triggers($duos) {
	$duos.forEach($duo => {
		const $content = $duo.querySelector(content_$);
		if (!$content) return;
		const selector = $duo.getAttribute(selector_attr);
		$content.querySelectorAll(selector).forEach(($item, i) => {
			$item.setAttribute(trigger_attr, i + 1);
		});
	});
}


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_dynamic_duo) return true;

	const $duos = document.querySelectorAll(duo_$);
	if (!$duos.length) return false;

	assign_triggers($duos);

	// Hovering or focusing a trigger shows its image, which stays after the
	// pointer or focus moves on.
	const on_enter = e => {
		if (!e.target.closest) return;
		const $trigger = e.target.closest(trigger_$);
		if (!$trigger) return;

		const $duo = $trigger.closest(duo_$);
		if (!$duo) return;

		activate_item($duo, $trigger.getAttribute(trigger_attr));
	};
	document.addEventListener(g.mouse_enter_e, on_enter, true);
	document.addEventListener('focusin', on_enter);

	return true;
}


/**
 * Show the image for an index. An index with no image shows the default.
 * @param {Element} $duo - The dynamic-duo container
 * @param {string} index - The item index to activate
 */
function activate_item($duo, index) {
	const $items = $duo.querySelectorAll(item_$);
	const has_match = [...$items].some($item => $item.getAttribute(item_attr) === index);
	const target = has_match ? index : $duo.getAttribute(default_attr);

	$items.forEach($item => {
		const is_match = $item.getAttribute(item_attr) === target;
		$item.setAttribute(g.is_active_attr, is_match ? g.true_s : g.false_s);
	});
}
